import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import ErrorBoundary from '../../molecules/ErrorBoundary'
import NavigationProvider from './NavigationProvider'
import Wheel from './Layouts/Wheel'
import GenericWheelProvider from './GenericWheelProvider'
import SubViewRoute from './components/SubViewRoute'

const mapItems = (root, config) => {
  return Object.entries(config || {}).map(([key, value]) => {
    return {
      key,
      to: `${root}/${value.path}`,
      view: value.path,
      ...value,
      type: value.type || 'link'
    }
  })
}

const GenericWheel = ({ settings, children, views, rootUrl, showMinimap, showCurrentClient, logo }) => {
  const { path, url } = useRouteMatch()
  const viewItems = useMemo(() => mapItems(rootUrl || url, views), [rootUrl, url, views])

  return (
    <ErrorBoundary name='Generic Wheel'>
      <Switch>
        <GenericWheelProvider
          settings={settings}
          dashboardItems={viewItems}
          root={rootUrl || url}
        >
          <NavigationProvider dashboardItems={viewItems} root={rootUrl || url} hideMinimap={!showMinimap}>
            <SecureRoute path={path} exact>
              <Wheel logo={logo}>
                {children}
              </Wheel>
            </SecureRoute>
            <SecureRoute path={`${path}/:subView`}>
              <SubViewRoute showCurrentClient={showCurrentClient} />
            </SecureRoute>
          </NavigationProvider>
        </GenericWheelProvider>
      </Switch>
    </ErrorBoundary>
  )
}

GenericWheel.propTypes = {
  settings: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  logo: PropTypes.node,
  views: PropTypes.objectOf(PropTypes.shape({
    path: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    imgSrc: PropTypes.string,
    hidden: PropTypes.bool
  })),
  rootUrl: PropTypes.string,
  showMinimap: PropTypes.bool,
  showCurrentClient: PropTypes.bool
}

export default GenericWheel
